import React, { useState } from "react";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import MobDataCollectionForms from "./MobDataCollectionForms";
import OpenCompagins from "./OpenCompagins";
import MobCentralDataCollection from "./MobCentralDataCollection";

function DataCollection() {
  const [tabId, setTabId] = useState("3");
  const whichTabIsActive = [false, false,true];
  const [tabActive, setTabActive] = useState(whichTabIsActive);
  const activeTab = (id) => {
    setTabId(id);
    var newtTabActive = [false, false, false, false, false];
    newtTabActive[id - 1] = true;
    setTabActive(newtTabActive);
  };
  return (
    <div>
      <Nav tabs style={{ border: "none", marginBottom: 0 }}>
         <NavItem>
          <NavLink
            className={tabActive[2] ? "active" : ""}
            onClick={() => activeTab("3")}
            href="#"
            style={{
              color: tabActive[2] ? "#22762B" : "#C2C2C2",
              paddingLeft: 0,
              fontWeight: 600,
              border: "none",
            }}
          >
            <h6 className="dashboard-nav-tabs">
              &nbsp; &nbsp;Targeted Campaigns
            </h6>
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={tabActive[0] ? "active" : ""}
            onClick={() => activeTab("1")}
            href="#"
            style={{
              color: tabActive[0] ? "#22762B" : "#C2C2C2",
              paddingLeft: 0,
              fontWeight: 600,
              border: "none",
            }}
          >
            <h6 className="dashboard-nav-tabs">
              &nbsp; &nbsp;Open Campaigns
            </h6>
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={tabActive[1] ? "active" : ""}
            onClick={() => activeTab("2")}
            href="#"
            style={{
              color: tabActive[1] ? "#22762B" : "#C2C2C2",
              paddingLeft: 0,
              fontWeight: 600,
              border: "none",
            }}
          >
            <h6 className="dashboard-nav-tabs">
              &nbsp; &nbsp;Archived&nbsp;Campaigns
            </h6>
          </NavLink>
        </NavItem>
      </Nav>
      <TabContent style={{ paddingTop: 20 }} activeTab={tabId}>
          <TabPane tabId="3" style={{ marginBottom: 50 }}>
          <MobCentralDataCollection/>
        </TabPane>
        <TabPane tabId="1" style={{ marginBottom: 50 }}>
          <OpenCompagins/>
        </TabPane>
        <TabPane tabId="2" style={{ marginBottom: 50 }}>
          <MobDataCollectionForms/>
        </TabPane>
      </TabContent>
    </div>
  );
}

export default DataCollection;
